import { Auth0Provider } from '@auth0/auth0-react';
import { isEmpty } from 'lodash';

const AuthProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const localStorageAuthContext = localStorage.getItem('auth.context');
  
  return (
    <Auth0Provider {...typeof localStorageAuthContext === 'string' && !isEmpty(localStorageAuthContext) ? JSON.parse(localStorageAuthContext) : {}}>
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
